// Originally generated from the single-file app (index.html) during the React migration.
// Edit freely: this file is now the source of truth.
import type { ColumnLayoutConfig } from "@/domain/types";

export const COLUMN_LAYOUT_CONFIG: ColumnLayoutConfig = {
  defaultLayoutId: "ageGroups",
  layouts: {
    ageGroups: {
      id: "ageGroups",
      type: "ageGroups",
      palette: "ageGroup",
      statsTitleKey: "ageTitle",
      stackedStatsTitleKey: "stackedAgeTitle",
    },
    tiltaksklasse: {
      id: "tiltaksklasse",
      type: "categoryFromRow",
      column: "Tiltaksklasse",
      palette: "tiltaksklasse",
      statsTitleKey: "tiltaksklasseTitle",
      stackedStatsTitleKey: "stackedTiltaksklasseTitle",
      predefinedCategories: [
        {
          key: "1 - Personorientert",
          label: {
            no: "Personorientert",
            en: "Person-oriented",
          },
        },
        {
          key: "2 - Situasjonsorientert",
          label: {
            no: "Situasjonsorientert",
            en: "Situation-oriented",
          },
        },
        {
          key: "3 - Lokalorientert",
          label: {
            no: "Lokalorientert",
            en: "Local-oriented",
          },
        },
        {
          key: "4 - Multikomponent",
          label: {
            no: "Multikomponent",
            en: "Multi-component",
          },
        },
      ],
    },
    initialFiltering: {
      id: "initialFiltering",
      type: "categoryFromRow",
      column: "Initial_filtering",
      palette: "initialFiltering",
      statsTitleKey: "initialFilteringTitle",
      stackedStatsTitleKey: "stackedInitialFilteringTitle",
      predefinedCategories: [
        {
          key: "1",
          label: {
            no: "Forebygging",
            en: "Prevention",
          },
        },
        {
          key: "2",
          label: {
            no: "Støttetjeneste",
            en: "Supporting services",
          },
        },
        {
          key: "3",
          label: {
            no: "Ikke forebygging",
            en: "Not prevention",
          },
        },
        {
          key: "4",
          label: {
            no: "Trenger mer informasjon",
            en: "Need more information",
          },
        },
      ],
    },
  },
};
